(function () {
  var requestId = 0;

  function carsLabel(n) {
    var mod10 = n % 10;
    var mod100 = n % 100;
    var word = 'vozů';
    if (n === 1) word = 'vůz';
    else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) word = 'vozy';
    return n + ' ' + word;
  }

  var arrow =
    '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function metaHtml(model) {
    var chips = [];
    String(model.types || '')
      .split(',')
      .concat(String(model.fuels || '').split(','))
      .concat(String(model.trims || '').split(','))
      .forEach(function (part) {
        var text = part.trim();
        if (text) chips.push(text);
      });
    chips.push(carsLabel(model.count || 0));
    return (
      '<ul class="brand-models__meta">' +
      chips
        .map(function (chip) {
          return '<li>' + esc(chip) + '</li>';
        })
        .join('') +
      '</ul>'
    );
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function modelHref(gid, paramName) {
    var url = new URL(window.location.href);
    var drop = [];
    url.searchParams.forEach(function (_, key) {
      if (key === 'page' || key === 'section_id' || key === 'view' || key.indexOf('car_model') !== -1) drop.push(key);
    });
    drop.forEach(function (key) {
      url.searchParams.delete(key);
    });
    url.searchParams.set(paramName || 'filter.p.m.custom.car_model', gid);
    return url.pathname + '?' + url.searchParams.toString();
  }

  function kc(cents) {
    var amount = Math.round(Number(cents) / 100);
    return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function cardHtml(model, note, paramName, buttonLabel) {
    var title = model.title || [model.make, model.name].filter(Boolean).join(' ');
    var alt = title + ' na operativní leasing';
    var meta = metaHtml(model);
    var href = modelHref(model.gid, paramName);
    var noteWith = String(note || '').replace('bez DPH', 's DPH');
    var image = model.image
      ? '<img src="' +
        esc(model.image) +
        '" alt="' +
        esc(alt) +
        '" width="500" height="375" loading="lazy" decoding="async" fetchpriority="low">'
      : '';
    var about = model.about ? '<p>' + esc(model.about) + '</p>' : '';
    var priceWithout = model.price_text || kc(model.price);
    var priceWith = kc(Math.round((Number(model.price) / 100) * 1.21) * 100);
    return (
      '<li class="brand-models__item">' +
      image +
      '<h3>' +
      esc(title) +
      '</h3>' +
      meta +
      about +
      '<span class="brand-models__price">' +
      '<span class="withoutVat">od ' +
      esc(priceWithout) +
      ' Kč<span class="brand-models__vat">' +
      esc(note) +
      '</span></span>' +
      '<span class="withVat">od ' +
      esc(priceWith) +
      ' Kč<span class="brand-models__vat">' +
      esc(noteWith) +
      '</span></span>' +
      '</span>' +
      '<span class="brand-models__btn">' +
      '<span class="brand-models__btn-full">' +
      esc(buttonLabel || 'Zobrazit nabídky') +
      '</span>' +
      '<span class="brand-models__btn-short">' +
      esc((buttonLabel || 'Zobrazit nabídky').split(' ')[0]) +
      '</span>' +
      arrow +
      '</span>' +
      '<a href="' +
      esc(href) +
      '" aria-label="' +
      esc((buttonLabel || 'Zobrazit nabídky') + ' ' + alt) +
      '"></a></li>'
    );
  }

  function mergeModels(rows) {
    var order = [];
    var map = {};
    rows.forEach(function (row) {
      if (!row || !row.models) return;
      row.models.forEach(function (model) {
        if (!model || !model.id) return;
        var current = map[model.id];
        if (!current) {
          map[model.id] = {
            id: model.id,
            name: model.name,
            make: model.make,
            title: model.title,
            count: model.count || 0,
            price: model.price,
            price_text: model.price_text,
            image: model.image,
            types: model.types || '',
            fuels: model.fuels || '',
            trims: model.trims || '',
            about: model.about || '',
            gid: model.gid,
          };
          order.push(model.id);
          return;
        }
        current.count += model.count || 0;
        if (model.price != null && (current.price == null || model.price < current.price)) {
          current.price = model.price;
          current.price_text = model.price_text;
          if (model.image) current.image = model.image;
        }
        if (!current.about && model.about) current.about = model.about;
        ['types', 'fuels', 'trims'].forEach(function (key) {
          var next = (model[key] || '').split(', ').filter(Boolean);
          var have = (current[key] || '').split(', ').filter(Boolean);
          next.forEach(function (part) {
            if (have.indexOf(part) === -1) have.push(part);
          });
          current[key] = have.join(', ');
        });
      });
    });
    return order.map(function (id) {
      return map[id];
    });
  }

  function refreshCollectionBrandModels() {
    var root = document.querySelector('[data-brand-models]');
    if (!root) return;
    var grid = root.querySelector('[data-brand-models-grid]');
    if (!grid) return;

    var total = Number(root.getAttribute('data-models-total') || 0);
    if (total < 1) return;

    var id = (requestId += 1);
    var pages = Math.max(1, Math.ceil(total / 50));
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.set('view', 'brand-models');

    var jobs = [];
    for (var page = 1; page <= pages; page += 1) {
      params.set('page', String(page));
      jobs.push(
        fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            return null;
          }),
      );
    }

    Promise.all(jobs).then(function (rows) {
      if (id !== requestId) return;
      if (!root.isConnected) return;

      var models = mergeModels(rows).filter(function (model) {
        return model && model.price != null && model.count > 0;
      });
      if (!models.length) return;

      var note = root.getAttribute('data-price-note') || 'měsíčně bez DPH';
      var buttonLabel = root.getAttribute('data-card-button') || 'Zobrazit nabídky';
      var paramName = root.getAttribute('data-model-param') || 'filter.p.m.custom.car_model';
      var cta = grid.querySelector('[data-brand-models-cta]');
      var ctaHtml = cta ? cta.outerHTML : '';
      grid.innerHTML =
        models
          .map(function (model) {
            return cardHtml(model, note, paramName, buttonLabel);
          })
          .join('') + ctaHtml;
    });
  }

  var brandModelsObserver = null;

  function scheduleCollectionBrandModels() {
    var root = document.querySelector('[data-collection-models-section-id]');
    if (!root) return;
    if (brandModelsObserver) brandModelsObserver.disconnect();
    if (!('IntersectionObserver' in window)) {
      refreshCollectionBrandModels();
      return;
    }
    brandModelsObserver = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        )
          return;
        brandModelsObserver.disconnect();
        brandModelsObserver = null;
        refreshCollectionBrandModels();
      },
      { rootMargin: '600px 0px' },
    );
    brandModelsObserver.observe(root);
  }

  window.refreshCollectionBrandModels = scheduleCollectionBrandModels;
  scheduleCollectionBrandModels();
})();
